import Template from './root.component'

// You can enable the Skeleton Loader implementation by importing Template from root.loader instead of root.component
//import Template from './root.loader';

export default Template
